export const NAME = 'signup'
export const PARENT_SIGNUP = 'signupParent'
export const LEADER_SIGNUP = 'signupLeader'



// WEBPACK FOOTER //
// ../source/views/Signup/constants.js